import type stockInId from "./id";

const stockInEn: typeof stockInId = {
	stock_in: {
		title: "Stock In",
		subtitle: "Summary of stock in records",
		table: {
			title: "Stock In Data",
			columns: {
				date: "Date",
				ref_id: "Ref ID",
				store: "Store",
				notes: "Notes",
				made_by: "Created By",
				status: "Status",
			},
		},
		empty_stock: {
			title: "No stock in data",
			description: "Please add new stock in data.",
		},
		forms: {
			edit: {
				title: "Edit Stock In",
				info: "Stock in information",
				fields: {
					ref_id: {
						label: "RefId",
						placeholder: "refId",
					},
					store: {
						label: "Store",
						placeholder: "Select Store",
					},
					notes: {
						label: "Notes",
						placeholder: "notes",
					},
					status: {
						label: "Status",
						placeholder: "Select Status",
					},
				},
				options: {
					active: "Active",
					inactive: "Inactive",
				},
			},
			add: {
				button: "Add Stock In",
				title: "Add Stock In",
				description: "Add a new stock in record",
				fields: {
					store: {
						label: "Store",
						placeholder: "Select Store",
					},
					notes: {
						label: "Notes",
						placeholder: "Enter Notes",
					},
					date_processing: {
						label: "Processing Date",
						placeholder: "11/11/2011",
					},
					product_detail: {
						not_found_product: "Product Not Found",
						title: "Product Detail",
						loading: "Loading products...",
						product: {
							label: "Product",
							placeholder: "Product",
							search_product: "Search product...",
						},
						qty: { label: "Qty", placeholder: "0" },
						unit: { label: "Unit", placeholder: "Pcs" },
						buy_price: {
							label: "Unit Buy Price",
							placeholder: "Rp 20,000,-",
						},
						total_price: "Total Price",
						action: {
							label: "Action",
						},
					},
				},
			},
		},
		actions: {
			add_product: "Add Product",
			cancel: "Cancel",
			save: "Save",
			saving: "Saving...",
			save_changes: "Save Changes",
			add_products: {
				already_added: "This product has already been added",
			},
		},
		status: {
			processed: "Processed",
			inactive: "Inactive",
		},
	},
};

export default stockInEn;
